import React from 'react'

const Assistance = ({color}) => {
  return (
    <svg viewBox="0 0 65 65">
      <path fill={color} d="M32.2,58.6C17.7,58.6,6,47,6,32.8C6,18.6,17.7,7,32.2,7s26.2,11.6,26.2,25.8C58.4,47,46.6,58.6,32.2,58.6z
	 M32.2,9C18.8,9,8,19.7,8,32.8s10.8,23.8,24.2,23.8c13.3,0,24.2-10.7,24.2-23.8S45.5,9,32.2,9z"/>
      <path fill={color} d="M32.1,48.8c-8.9,0-16.1-7.1-16.1-15.9C16,24.1,23.2,17,32.1,17c8.9,0,16.1,7.1,16.1,15.9
	C48.2,41.6,41,48.8,32.1,48.8z M32.1,19C24.3,19,18,25.2,18,32.9s6.3,13.9,14.1,13.9s14.1-6.2,14.1-13.9S39.9,19,32.1,19z"/>
      <path fill={color} d="M25.6,57.8c-0.1,0-0.1,0-0.2,0c-0.5-0.1-0.9-0.6-0.8-1.2l1.7-9.8c0.1-0.5,0.6-0.9,1.2-0.8
	c0.5,0.1,0.9,0.6,0.8,1.2L26.6,57C26.5,57.5,26.1,57.8,25.6,57.8z M39,57.8c-0.5,0-0.9-0.3-1-0.8l-1.7-9.7c-0.1-0.5,0.3-1.1,0.8-1.2
	c0.6-0.1,1.1,0.3,1.2,0.8l1.7,9.7c0.1,0.5-0.3,1.1-0.8,1.2C39.1,57.7,39.1,57.8,39,57.8z M8.1,40.5c-0.5,0-0.9-0.3-1-0.8
	c-0.1-0.5,0.3-1.1,0.8-1.2l9.8-1.7c0.5-0.1,1.1,0.3,1.2,0.8c0.1,0.5-0.3,1.1-0.8,1.2l-9.8,1.7C8.2,40.5,8.2,40.5,8.1,40.5z
	 M56.5,40.5c-0.1,0-0.1,0-0.2,0l-9.8-1.7c-0.5-0.1-0.9-0.6-0.8-1.2c0.1-0.5,0.6-0.9,1.2-0.8l9.8,1.7c0.5,0.1,0.9,0.6,0.8,1.2
	C57.4,40.2,57,40.5,56.5,40.5z M46.6,29c-0.5,0-0.9-0.3-1-0.8c-0.1-0.5,0.3-1.1,0.8-1.2l9.9-1.6c0.5-0.1,1.1,0.3,1.2,0.8
	c0.1,0.5-0.3,1.1-0.8,1.2L46.8,29C46.7,29,46.7,29,46.6,29z M17.9,29c-0.1,0-0.1,0-0.2,0l-9.9-1.6c-0.5-0.1-0.9-0.6-0.8-1.2
	c0.1-0.5,0.6-0.9,1.2-0.8L18,27c0.5,0.1,0.9,0.6,0.8,1.2C18.8,28.7,18.4,29,17.9,29z M37.3,19.8c-0.1,0-0.1,0-0.2,0
	c-0.5-0.1-0.9-0.6-0.8-1.2L38,8.9c0.1-0.5,0.6-0.9,1.2-0.8c0.5,0.1,0.9,0.6,0.8,1.2L38.3,19C38.2,19.5,37.8,19.8,37.3,19.8z
	 M27.3,19.8c-0.5,0-0.9-0.3-1-0.8l-1.7-9.8c-0.1-0.5,0.3-1.1,0.8-1.2c0.5-0.1,1.1,0.3,1.2,0.8l1.7,9.8c0.1,0.5-0.3,1.1-0.8,1.2
	C27.4,19.8,27.4,19.8,27.3,19.8z"/>
    </svg>
  )
}

export default Assistance
